
import service from 'kts-platform-frame/service';
import ReactBox from 'grey-react-box';
import { Modal } from 'kts-xui';
import React from 'react';
import WarningContent from './WarningContent';

const css = require('./index.scss');

export interface IResourceItem {
    resourceCode: string
    appKey: string
}

export class AppResourceState {

    isInit = false;

    resourceList: IResourceItem[] = [];
}

/** 应用权限资源管理器 */

export default class AppResource extends ReactBox<AppResourceState> {

    constructor(appKey: string) {
        super(new AppResourceState)
        this.init(appKey)
    }

    init = this.pipeline<string>(async (s, appKey) => {
        const api = await service.get('/api/external/private/access/user-access/resource/query').query({ appKey }).set({ 'x-kxl-app-key': appKey || null }).end(this)

        if (api.err) { return; }

        s.resourceList = api.res;
        s.isInit = true;
    })

    /** 校验权限方法的装饰器 */
    check: (key: string) => <T extends Function>(fn: T) => T = key => (fn) => {
        return ((...par: any[]) => {
            if (this.isHave(key)) {
                return fn.apply(null, par);
            } else {
                Modal.warning({
                    icon: null,
                    className: css.modalWarning,
                    content: <WarningContent />
                });
                return undefined;
            }
        }) as any
    }

    /** 是否有权限 */
    isHave = (key: string) => {
        console.log('===> [权限资源]', key);
        return this.state.resourceList.some(e => e.resourceCode === 'ALL' || e.resourceCode === key);
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/appSdk/AppResource/index.tsx